import * as Yup from 'yup';

import { Form, Select, Text } from '../../../../Components/Form';
import { getTypes } from '../../Utils/Helper';

const validationSchema = Yup.object({
  national_card_id: Yup.string()
    .nullable()
    .min(10, 'کد ملی باید 10 رقم باشد.')
    .max(10, 'کد ملی باید 10 رقم باشد.'),
  province_id: Yup.number().typeError('').nullable(),
  type: Yup.number()
    .typeError('نوع باید انتخاب شود')
    .required('نوع باید انتخاب شود'),
});

const Search = ({
  searchUser,
  context,
  serverErrors,
  searchLoading,
  addRank,
}) => {
  return (
    <div className='col-12 col-md-12 my-3'>
      <Form
        initialValues={{
          national_card_id: '',
          province_id: '',
          type: '',
        }}
        validationSchema={validationSchema}
        defaultActions={false}
        onSubmit={searchUser}
      >
        <div className='row'>
          <div className='col-12 col-md-3'>
            <Text
              name='national_card_id'
              title='کد ملی *'
              serverError={serverErrors?.national_card_id}
              containerClass='d-flex flex-column justify-content-start align-items-start'
              labelClass='tetx-right mx-2 f-13'
            />
          </div>
          <div className='col-12 col-md-3'>
            <Select
              title='استان'
              options={context?.provinces}
              optionLabel='name'
              optionValue='id'
              name='province_id'
              serverError={serverErrors?.province_id}
            />
          </div>
          <div className='col-12 col-md-3'>
            <Select
              title='نوع'
              options={getTypes}
              optionLabel='label'
              optionValue='value'
              name='type'
              serverError={serverErrors?.type}
            />
          </div>
          <div className='col-12 col-md-3 mt-4'>
            {searchLoading ? (
              <button className='btn bg-purple w-100 f-13 text-white mt-1'>
                <div
                  className='spinner-border text-white spinner-border-sm mb-1'
                  role='status'
                >
                  <span className='sr-only'></span>
                </div>
              </button>
            ) : (
              <button
                type='submit'
                className='btn bg-purple w-100 f-13 text-white mt-1'
              >
                جستجو
              </button>
            )}
          </div>

          {/* {searchLoading
            ? null
            : context.user?.id !== undefined && (
                <>
                  <div className='col-12'>
                    <div className='d-flex flex-row my-4 border-bottom border-dark'>
                      <h1 className='text-dark f-14 font-weight-bold'>
                        مشخصات کاربر جستجو شده
                      </h1>
                    </div>
                  </div>
                  <div className='col-12 col-md-3 my-3'>
                    <div className='d-flex flex-row align-items-center'>
                      <span className='text-dark f-14 mx-2'>
                        نام و نام خانوادگی :{' '}
                      </span>
                      <span className='text-dark f-14 mx-2'>
                        {context?.user?.name} {context?.user?.last_name}
                      </span>
                    </div>
                  </div>
                  <div className='col-12 col-md-3 my-3'>
                    <div className='d-flex flex-row align-items-center'>
                      <span className='text-dark f-14 mx-2'>نام پدر : </span>
                      <span className='text-dark f-14 mx-2'>
                        {context?.user?.father_name}
                      </span>
                    </div>
                  </div>
                  <div className='col-12 col-md-3 my-3'>
                    <div className='d-flex flex-row align-items-center'>
                      <span className='text-dark f-14 mx-2'>کدملی : </span>
                      <span className='text-dark f-14 mx-2'>
                        {context?.user?.national_card_id}
                      </span>
                    </div>
                  </div>
                  <div className='col-12 col-md-3 my-3'>
                    <div className='d-flex flex-row align-items-center'>
                      <span className='text-dark f-14 mx-2'>
                        شماره همراه :{' '}
                      </span>
                      <span className='text-dark f-14 mx-2'>
                        {context?.user?.mobile}
                      </span>
                    </div>
                  </div>
                  <div className='col-12 col-md-3 my-3'>
                    <div className='d-flex flex-row align-items-center'>
                      <span className='text-dark f-14 mx-2'>
                        استان محل زندگی:{' '}
                      </span>
                      <span className='text-dark f-14 mx-2'>
                        {context?.user?.province_living?.name}
                      </span>
                    </div>
                  </div>
                  <div className='col-12 col-md-3 my-3'>
                    <div className='d-flex flex-row align-items-center'>
                      <span className='text-dark f-14 mx-2'>تاریخ تولد : </span>
                      <span className='text-dark f-14 mx-2'>
                        {dateToJalali(context?.user?.birthday)}
                      </span>
                    </div>
                  </div>
                  <div className='col-12 col-md-6 my-3'>
                    <div className='d-flex flex-row align-items-center'>
                      <span className='text-dark f-14 mx-2'> آدرس : </span>
                      <span className='text-dark f-14 mx-2'>
                        {context?.user?.address}
                      </span>
                    </div>
                  </div>
                  <div className='col-12 my-3'>
                    <div className='d-flex flex-row align-items-center justify-content-end'>
                      <div className='form-group'>
                        <label className='text-dark f-13 d-flex flex-row justify-content-start'>
                          انتخاب سمت
                        </label>
                      </div>
                      <div className='form-group mx-2'>
                        <Select
                          options={[]}
                          optionLabel='side'
                          optionValue='id'
                          formikOnChange={false}
                          onChange={(val) => {}}
                        />
                      </div>
                      <div className='form-group mx-2'>
                        <button
                          onClick={() => {}}
                          type='button'
                          className='btn btn-info text-white f-13 mx-2 mb-2 '
                        >
                          افزودن کاربر
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )} */}
          {searchLoading ? null : context.users?.length > 0 ? (
            <div className='col-12'>
              <h1 className='text-dark f-15 font-weight-bold mx-2'>
                لیست کاربران :{' '}
              </h1>
              <table className='table table-hover table-striped overflow-hidden rounded-1 shadow-sm text-left'>
                <>
                  <thead className='thead-persian-green text-left'>
                    <tr>
                      <th>#</th>
                      <th>نام</th>
                      <th>نام خانوادگی</th>
                      <th>کد ملی</th>
                      <th>ثبت مقام</th>
                    </tr>
                  </thead>
                  <tbody>
                    {context.users?.map((user, index) => (
                      <tr>
                        <td className='d-flex flex-row align-items-center'>
                          {index + 1}
                        </td>
                        <td>{user?.name}</td>
                        <td>{user?.last_name}</td>
                        <td>{user?.national_card_id}</td>

                        <td>
                          <button
                            className='btn bg-purple f-13 text-white mt-1'
                            onClick={() => {
                              addRank({
                                id: null,
                                modelId: user?.id,
                                title: user?.name + ' ' + user?.last_name,
                                rank: null,
                                type: user?.type,
                                ethics_card: 0,
                                sport_id: 0,
                                province_id: user?.province_living_id,
                                weight_id: 0,
                                age_id: null,
                              });
                            }}
                          >
                            افزودن به مقام ها
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </>
              </table>
            </div>
          ) : null}
        </div>
      </Form>
    </div>
  );
};

export default Search;
